// import api from './api';

// class SaleService {
//   /**
//    * Get customers by route
//    * @param {number} routeId - Route ID
//    * @returns {Promise} API response
//    */
//   static async getCustomersByRoute(routeId) {
//     try {
//       const response = await api.get(`/customers/routes/drop/${routeId}`);
//       return response.data;
//     } catch (error) {
//       console.error('Error fetching customers by route:', error);
//       throw this.handleError(error);
//     }
//   }

//   /**
//    * Get inventory stock
//    * @param {number} inventoryId - Inventory ID
//    * @returns {Promise} API response
//    */
//   static async getInventoryStock(inventoryId) {
//     try {
//       const response = await api.get(`/stocks/by-inventory/${inventoryId}`);
//       return response.data;
//     } catch (error) {
//       console.error('Error fetching inventory stock:', error);
//       throw this.handleError(error);
//     }
//   }

//   /**
//    * Get available routes
//    * @returns {Promise} API response
//    */
//   static async getAvailableRoutes() {
//     try {
//       const response = await api.get('/routes/available');
//       return response.data;
//     } catch (error) {
//       console.error('Error fetching available routes:', error);
//       throw this.handleError(error);
//     }
//   }

//   /**
//    * Get invoice number
//    * @returns {Promise} API response
//    */
//   static async getInvoiceNumber() {
//     try {
//       const response = await api.get('/sales/invoice-number');
//       return response.data;
//     } catch (error) {
//       console.error('Error fetching invoice number:', error);
//       throw this.handleError(error);
//     }
//   }

//   /**
//    * Create a new sale
//    * @param {Object} saleData - Sale data
//    * @returns {Promise} API response
//    */
//   static async createSale(saleData) {
//     try {
//       const response = await api.post('/sales/user/create', saleData);
//       return response.data;
//     } catch (error) {
//       console.error('Error creating sale:', error);
//       throw this.handleError(error);
//     }
//   }

//   /**
//    * Get customer credit balance
//    * @param {number} customerId - Customer ID
//    * @param {number} routeId - Route ID
//    * @returns {Promise} API response
//    */
//   static async getCustomerCreditBalance(customerId, routeId) {
//     try {
//       const response = await api.get(`/credits/${customerId}/${routeId}/balance`);
//       return response.data;
//     } catch (error) {
//       console.error('Error fetching customer credit balance:', error);
//       throw this.handleError(error);
//     }
//   }

//   /**
//    * Process debt collection
//    * @param {Object} paymentData - Payment data
//    * @returns {Promise} API response
//    */
//   static async processDebtCollection(paymentData) {
//     try {
//       const response = await api.post('/credits/pay-balance', paymentData);
//       return response.data;
//     } catch (error) {
//       console.error('Error processing debt collection:', error);
//       throw this.handleError(error);
//     }
//   }

//   /**
//    * Validate sale data
//    * @param {Object} saleData - Sale data to validate
//    * @returns {Object} Validation result
//    */
//   static validateSaleData(saleData) {
//     const errors = [];

//     if (!saleData.customerId) {
//       errors.push('Customer ID is required');
//     }

//     if (!saleData.routeId) {
//       errors.push('Route ID is required');
//     }

//     if (!saleData.inventoryId) {
//       errors.push('Inventory ID is required');
//     }

//     if (!saleData.products || saleData.products.length === 0) {
//       errors.push('At least one product is required');
//     } else {
//       saleData.products.forEach((product, index) => {
//         if (!product.productId) {
//           errors.push(`Product ${index + 1}: Product ID is required`);
//         }
//         if (!product.categoryId) {
//           errors.push(`Product ${index + 1}: Category ID is required`);
//         }
//         if (!product.pricePerUnit || product.pricePerUnit <= 0) {
//           errors.push(`Product ${index + 1}: Valid price per unit is required`);
//         }
//         if (!product.qty || product.qty <= 0) {
//           errors.push(`Product ${index + 1}: Valid quantity is required`);
//         }
//       });
//     }

//     if (!saleData.paymentMethods || saleData.paymentMethods.length === 0) {
//       errors.push('At least one payment method is required');
//     } else {
//       let totalPaymentAmount = 0;
//       saleData.paymentMethods.forEach((payment, index) => {
//         const validMethods = ['CASH', 'CHEQUE', 'BANK_TRANSFER', 'CREDIT'];
        
//         if (!validMethods.includes(payment.method)) {
//           errors.push(`Payment ${index + 1}: Invalid payment method. Use: ${validMethods.join(', ')}`);
//         }
        
//         if (!payment.amount || payment.amount <= 0) {
//           errors.push(`Payment ${index + 1}: Valid amount is required`);
//         }
        
//         totalPaymentAmount += parseFloat(payment.amount || 0);

//         // Validate cheque details
//         if (payment.method === 'CHEQUE') {
//           if (!payment.chequeNumber || payment.chequeNumber.trim() === '') {
//             errors.push(`Payment ${index + 1}: Cheque number is required for cheque payments`);
//           }
//           if (!payment.bank || payment.bank.trim() === '') {
//             errors.push(`Payment ${index + 1}: Bank name is required for cheque payments`);
//           }
//         }

//         // Validate bank transfer details
//         if (payment.method === 'BANK_TRANSFER') {
//           if (!payment.reference || payment.reference.trim() === '') {
//             errors.push(`Payment ${index + 1}: Reference number is required for bank transfers`);
//           }
//         }
//       });

//       // Calculate total sale amount
//       const totalSaleAmount = saleData.products.reduce((total, product) => {
//         return total + (product.pricePerUnit * product.qty);
//       }, 0);

//       // Apply return if exists
//       const netSaleAmount = totalSaleAmount - (saleData.productreturnData?.amount || 0);

//       if (totalPaymentAmount > netSaleAmount) {
//         errors.push('Total payment amount cannot exceed total sale amount');
//       }
//     }

//     return {
//       isValid: errors.length === 0,
//       errors
//     };
//   }

//   /**
//    * Prepare sale data for API
//    * @param {Object} data - Raw sale data
//    * @returns {Object} Formatted sale data
//    */
//   static prepareSaleData(data) {
//     // Calculate totals
//     const totalAmount = data.products.reduce((total, product) => {
//       return total + (product.pricePerUnit * product.qty);
//     }, 0);

//     const returnAmount = data.productreturnData?.amount || 0;
//     const netAmount = totalAmount - returnAmount;

//     // Calculate paid amount
//     const paidAmount = data.paymentMethods.reduce((total, payment) => {
//       return total + parseFloat(payment.amount);
//     }, 0);

//     // Calculate remaining balance (if credit created)
//     const remainingBalance = netAmount - paidAmount;

//     const saleData = {
//       customerId: parseInt(data.customerId),
//       routeId: parseInt(data.routeId),
//       inventoryId: parseInt(data.inventoryId),
//       products: data.products.map(product => ({
//         productId: parseInt(product.productId),
//         categoryId: parseInt(product.categoryId),
//         pricePerUnit: parseFloat(product.pricePerUnit),
//         qty: parseInt(product.qty)
//       })),
//       paymentMethods: data.paymentMethods.map(payment => {
//         const base = {
//           method: payment.method,
//           amount: parseFloat(payment.amount)
//         };

//         if (payment.method === 'CHEQUE') {
//           base.chequeNumber = payment.chequeNumber;
//           base.bank = payment.bank;
//           if (payment.chequeId) {
//             base.chequeId = parseInt(payment.chequeId);
//           }
//         }

//         if (payment.method === 'BANK_TRANSFER') {
//           base.reference = payment.reference;
//           if (payment.bank) {
//             base.bank = payment.bank;
//           }
//         }

//         return base;
//       }),
//       totalAmount: parseFloat(totalAmount.toFixed(2)),
//       paidAmount: parseFloat(paidAmount.toFixed(2)),
//       remainingBalance: parseFloat(Math.max(0, remainingBalance).toFixed(2))
//     };

//     // Add return data if exists
//     if (returnAmount > 0) {
//       saleData.productreturnData = {
//         amount: parseFloat(returnAmount.toFixed(2))
//       };
//     }

//     // Add metadata
//     saleData.metadata = {
//       timestamp: new Date().toISOString(),
//       hasReturn: returnAmount > 0,
//       hasCredit: remainingBalance > 0,
//       netAmount: parseFloat(netAmount.toFixed(2))
//     };

//     return saleData;
//   }

//   /**
//    * Handle API errors
//    * @param {Error} error - Error object
//    * @returns {Object} Formatted error
//    */
//   static handleError(error) {
//     if (error.response) {
//       const { status, data } = error.response;
      
//       switch (status) {
//         case 400:
//           return {
//             message: data.message || 'Bad request. Please check your input.',
//             errors: data.errors || [],
//             status
//           };
        
//         case 401:
//           return {
//             message: 'Session expired. Please login again.',
//             status
//           };
        
//         case 403:
//           return {
//             message: 'You do not have permission to perform this action.',
//             status
//           };
        
//         case 422:
//           return {
//             message: 'Validation failed. Please check your input.',
//             errors: data.errors || [],
//             status
//           };
        
//         case 500:
//           return {
//             message: 'Server error. Please try again later.',
//             status
//           };
        
//         default:
//           return {
//             message: data.message || 'An unexpected error occurred.',
//             status
//           };
//       }
//     } else if (error.request) {
//       return {
//         message: 'Network error. Please check your internet connection.',
//         status: 0
//       };
//     } else {
//       return {
//         message: error.message || 'An unexpected error occurred.',
//         status: -1
//       };
//     }
//   }

//   /**
//    * Generate sale summary for display
//    * @param {Object} saleData - Sale data
//    * @returns {Object} Summary object
//    */
//   static generateSummary(saleData) {
//     const totalAmount = saleData.products.reduce((total, product) => {
//       return total + (product.pricePerUnit * product.qty);
//     }, 0);

//     const returnAmount = saleData.productreturnData?.amount || 0;
//     const netAmount = totalAmount - returnAmount;

//     const paidAmount = saleData.paymentMethods.reduce((total, payment) => {
//       return total + parseFloat(payment.amount);
//     }, 0);

//     const remainingBalance = netAmount - paidAmount;

//     return {
//       totalAmount: parseFloat(totalAmount.toFixed(2)),
//       returnAmount: parseFloat(returnAmount.toFixed(2)),
//       netAmount: parseFloat(netAmount.toFixed(2)),
//       paidAmount: parseFloat(paidAmount.toFixed(2)),
//       remainingBalance: parseFloat(Math.max(0, remainingBalance).toFixed(2)),
//       changeDue: parseFloat(Math.abs(Math.min(0, remainingBalance)).toFixed(2)),
//       hasReturn: returnAmount > 0,
//       hasCredit: remainingBalance > 0,
//       isFullyPaid: remainingBalance <= 0
//     };
//   }
// }

// export default SaleService;

// SaleService.js
import api from './api';

class SaleService {
  /**
   * Get customers by route
   * @param {number} routeId - Route ID
   * @returns {Promise} API response
   */
  static async getCustomersByRoute(routeId) {
    try {
      const response = await api.get(`/customers/routes/drop/${routeId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching customers by route:', error);
      throw this.handleError(error);
    }
  }

  /**
   * Get inventory stock
   * @param {number} inventoryId - Inventory ID
   * @returns {Promise} API response
   */
  static async getInventoryStock(inventoryId) {
    try {
      const response = await api.get(`/stocks/by-inventory/${inventoryId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching inventory stock:', error);
      throw this.handleError(error);
    }
  }

  /**
   * Get available routes
   * @returns {Promise} API response
   */
  static async getAvailableRoutes() {
    try {
      const response = await api.get('/routes/available');
      return response.data;
    } catch (error) {
      console.error('Error fetching available routes:', error);
      throw this.handleError(error);
    }
  }

  /**
   * Get invoice number
   * @returns {Promise} API response
   */
  static async getInvoiceNumber() {
    try {
      const response = await api.get('/sales/invoice-number');
      return response.data;
    } catch (error) {
      console.error('Error fetching invoice number:', error);
      throw this.handleError(error);
    }
  }

  /**
   * Create a new sale
   * @param {Object} saleData - Sale data
   * @returns {Promise} API response
   */
  static async createSale(saleData) {
    try {
      const response = await api.post('/sales/user/create', saleData);
      return response.data;
    } catch (error) {
      console.error('Error creating sale:', error);
      throw this.handleError(error);
    }
  }

  /**
   * Get customer credit balance
   * @param {number} customerId - Customer ID
   * @param {number} routeId - Route ID
   * @returns {Promise} API response
   */
  static async getCustomerCreditBalance(customerId, routeId) {
    try {
      const response = await api.get(`/credits/${customerId}/${routeId}/balance`);
      return response.data;
    } catch (error) {
      console.error('Error fetching customer credit balance:', error);
      throw this.handleError(error);
    }
  }

  /**
   * Process debt collection
   * @param {Object} paymentData - Payment data
   * @returns {Promise} API response
   */
  static async processDebtCollection(paymentData) {
    try {
      const response = await api.post('/credits/pay-balance', paymentData);
      return response.data;
    } catch (error) {
      console.error('Error processing debt collection:', error);
      throw this.handleError(error);
    }
  }

  /**
   * Validate sale data
   * @param {Object} saleData - Sale data to validate
   * @returns {Object} Validation result
   */
  static validateSaleData(saleData) {
    const errors = [];

    if (!saleData.customerId) {
      errors.push('Customer ID is required');
    }

    if (!saleData.routeId) {
      errors.push('Route ID is required');
    }

    if (!saleData.inventoryId) {
      errors.push('Inventory ID is required');
    }

    if (!saleData.products || saleData.products.length === 0) {
      errors.push('At least one product is required');
    } else {
      saleData.products.forEach((product, index) => {
        if (!product.productId) {
          errors.push(`Product ${index + 1}: Product ID is required`);
        }
        // REMOVED categoryId validation - not required in new API
        if (!product.pricePerUnit || product.pricePerUnit <= 0) {
          errors.push(`Product ${index + 1}: Valid price per unit is required`);
        }
        if (!product.qty || product.qty <= 0) {
          errors.push(`Product ${index + 1}: Valid quantity is required`);
        }
      });
    }

    if (!saleData.paymentMethods || saleData.paymentMethods.length === 0) {
      errors.push('At least one payment method is required');
    } else {
      let totalPaymentAmount = 0;
      saleData.paymentMethods.forEach((payment, index) => {
        const validMethods = ['CASH', 'CHEQUE', 'BANK_TRANSFER', 'CREDIT'];
        
        if (!validMethods.includes(payment.method)) {
          errors.push(`Payment ${index + 1}: Invalid payment method. Use: ${validMethods.join(', ')}`);
        }
        
        if (!payment.amount || payment.amount <= 0) {
          errors.push(`Payment ${index + 1}: Valid amount is required`);
        }
        
        totalPaymentAmount += parseFloat(payment.amount || 0);

        // Validate cheque details
        if (payment.method === 'CHEQUE') {
          if (!payment.chequeNumber || payment.chequeNumber.trim() === '') {
            errors.push(`Payment ${index + 1}: Cheque number is required for cheque payments`);
          }
          // Bank is now optional for cheque payments
        }

        // Validate bank transfer details
        if (payment.method === 'BANK_TRANSFER') {
          // Reference is now optional for bank transfers
        }
      });

      // Calculate total sale amount
      const totalSaleAmount = saleData.products.reduce((total, product) => {
        return total + (product.pricePerUnit * product.qty);
      }, 0);

      // Apply return if exists
      const netSaleAmount = totalSaleAmount - (saleData.productreturnData?.amount || 0);

      if (totalPaymentAmount > netSaleAmount) {
        errors.push('Total payment amount cannot exceed total sale amount');
      }
    }

    return {
      isValid: errors.length === 0,
      errors
    };
  }

  /**
   * Prepare sale data for API - UPDATED to match new JSON structure
   * @param {Object} data - Raw sale data
   * @returns {Object} Formatted sale data
   */
  static prepareSaleData(data) {
    // Calculate totals (for reference only, not sent to API)
    const totalAmount = data.products.reduce((total, product) => {
      return total + (product.pricePerUnit * product.qty);
    }, 0);

    const returnAmount = data.productreturnData?.amount || 0;
    const netAmount = totalAmount - returnAmount;

    // Calculate paid amount
    const paidAmount = data.paymentMethods.reduce((total, payment) => {
      return total + parseFloat(payment.amount);
    }, 0);

    // Calculate remaining balance (if credit created)
    const remainingBalance = netAmount - paidAmount;

    // Build the sale data according to the new JSON structure
    const saleData = {
      customerId: parseInt(data.customerId),
      routeId: parseInt(data.routeId),
      inventoryId: parseInt(data.inventoryId),
      products: data.products.map(product => ({
        productId: parseInt(product.productId), // Only productId, no categoryId
        qty: parseInt(product.qty),
        pricePerUnit: parseFloat(product.pricePerUnit)
      })),
      paymentMethods: data.paymentMethods.map(payment => {
        const paymentObj = {
          method: payment.method,
          amount: parseFloat(payment.amount)
        };

        // Add optional fields only if they exist
        if (payment.method === 'CHEQUE' && payment.chequeNumber) {
          paymentObj.chequeNumber = payment.chequeNumber;
        }
        
        if (payment.method === 'BANK_TRANSFER' && payment.reference) {
          paymentObj.reference = payment.reference;
        }
        
        // Bank is optional for all payment methods
        if (payment.bank) {
          paymentObj.bank = payment.bank;
        }

        return paymentObj;
      })
    };

    // Add return data if exists (only amount is required, reason is optional)
    if (returnAmount > 0) {
      saleData.productreturnData = {
        amount: parseFloat(returnAmount.toFixed(2))
      };
      
      // Add reason if provided
      if (data.productreturnData?.reason) {
        saleData.productreturnData.reason = data.productreturnData.reason;
      }
    }

    return saleData;
  }

  /**
   * Handle API errors
   * @param {Error} error - Error object
   * @returns {Object} Formatted error
   */
  static handleError(error) {
    if (error.response) {
      const { status, data } = error.response;
      
      switch (status) {
        case 400:
          return {
            message: data.message || 'Bad request. Please check your input.',
            errors: data.errors || [],
            status
          };
        
        case 401:
          return {
            message: 'Session expired. Please login again.',
            status
          };
        
        case 403:
          return {
            message: 'You do not have permission to perform this action.',
            status
          };
        
        case 422:
          return {
            message: 'Validation failed. Please check your input.',
            errors: data.errors || [],
            status
          };
        
        case 500:
          return {
            message: 'Server error. Please try again later.',
            status
          };
        
        default:
          return {
            message: data.message || 'An unexpected error occurred.',
            status
          };
      }
    } else if (error.request) {
      return {
        message: 'Network error. Please check your internet connection.',
        status: 0
      };
    } else {
      return {
        message: error.message || 'An unexpected error occurred.',
        status: -1
      };
    }
  }

  /**
   * Generate sale summary for display
   * @param {Object} saleData - Sale data
   * @returns {Object} Summary object
   */
  static generateSummary(saleData) {
    const totalAmount = saleData.products.reduce((total, product) => {
      return total + (product.pricePerUnit * product.qty);
    }, 0);

    const returnAmount = saleData.productreturnData?.amount || 0;
    const netAmount = totalAmount - returnAmount;

    const paidAmount = saleData.paymentMethods.reduce((total, payment) => {
      return total + parseFloat(payment.amount);
    }, 0);

    const remainingBalance = netAmount - paidAmount;

    return {
      totalAmount: parseFloat(totalAmount.toFixed(2)),
      returnAmount: parseFloat(returnAmount.toFixed(2)),
      netAmount: parseFloat(netAmount.toFixed(2)),
      paidAmount: parseFloat(paidAmount.toFixed(2)),
      remainingBalance: parseFloat(Math.max(0, remainingBalance).toFixed(2)),
      changeDue: parseFloat(Math.abs(Math.min(0, remainingBalance)).toFixed(2)),
      hasReturn: returnAmount > 0,
      hasCredit: remainingBalance > 0,
      isFullyPaid: remainingBalance <= 0
    };
  }
}

export default SaleService;